import type { LucideProps } from 'lucide-react'

// "Sheet with entries": the Project sheet grid in miniature, drawn on lucide's 24px grid.
export function ProjectSheetIcon({
  size = 24,
  strokeWidth = 2,
  color = 'currentColor',
  ...props
}: LucideProps): React.JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      <rect x="3" y="4" width="18" height="16" rx="2" />
      <path d="M3 9h18" />
      <path d="M9 9v11" />
      <path d="M13 13h4" />
      <path d="M13 16.5h2" />
    </svg>
  )
}
